import Space from 'antd/lib/space'
import styles from './TaskPanelHeader.module.less'
import Flex from 'antd/lib/flex'
import Tooltip from 'antd/lib/tooltip'

type PanelHeaderButtonPropsType = {
    action: () => void
    title: string
    icon: string
}

type PanelHeaderPropsType = {
    className?: string
    logo?: string
    title: string
    actionButtons?: PanelHeaderButtonPropsType[]
}

export const PanelHeader = (props: PanelHeaderPropsType) => {
    return (
        <Space
            className={
                styles['task-header-container'] + (props.className ? styles[props.className] : '')
            }
            data-testid="panel-header-wrapper"
        >
            <Flex
                align="center"
                justify="space-between"
                gap={'middle'}
                rootClassName={styles['task-header']}
            >
                <Flex align="center" vertical justify="flex-start">
                    <Space className={styles['logo-with-header']}>
                        {props.logo && (
                            <div className={styles['logo']}>
                                {<img src={props.logo} alt={props.title} />}
                            </div>
                        )}
                        <div className={styles['title']}>{props.title}</div>
                    </Space>
                </Flex>
                <Flex align="end" justify="start" gap={'small'}>
                    {props.actionButtons &&
                        props.actionButtons.length > 0 &&
                        props.actionButtons.map((actionButton: PanelHeaderButtonPropsType) => (
                            <Tooltip
                                title={actionButton.title}
                                key={actionButton.title}
                                placement="bottom"
                            >
                                <button
                                    className={styles['action-button-icon-wrapper']}
                                    onClick={actionButton.action}
                                    data-testid="action-buttons"
                                >
                                    <img
                                        src={actionButton.icon}
                                        alt={actionButton.title}
                                        className={styles['action-button-icon']}
                                    />
                                </button>
                            </Tooltip>
                        ))}
                </Flex>
            </Flex>
        </Space>
    )
}
